const SirenIcon = ({ strokeColor = '#808080' }) => (
  <svg
    id="Layer_2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 795.1 795.1"
  >
    <defs>
      <style>{`
        .cls-1 {
          fill: #fcfcfc;
        }
        .cls-2 {
          fill: #4d4d4d;
        }
        .cls-3 {
          stroke: ${strokeColor};
          stroke-width: 50px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-4 {
          stroke: #fff;
          stroke-width: 20px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-5 {
          fill: #fbfbfb;
        }
      `}</style>
    </defs>

    <g id="Circles">
      <circle className="cls-2" cx="397.55" cy="397.55" r="388.66" />
      <circle className="cls-3" cx="397.55" cy="397.55" r="372.55" />
      <circle className="cls-4" cx="397.55" cy="397.55" r="343.4" />
    </g>

    <g id="Shapes">
      <path
        className="cls-1"
        d="M497.13,326.18c21.08,27.51,27.86,58.62,27.47,91.93-.32,27.1-.25,54.21-.62,81.3-.08,6.15,1.99,8.7,8.27,8.06,4.15-.43,8.37-.11,12.57-.07,15.94.15,25.19,8.27,25.73,24.24.64,18.98.43,38,.11,57-.17,9.94-8.43,18.48-18.5,19.33-9.16.77-18.4.82-27.61.83-89.14.08-178.28.09-267.42.06-4.46,0-8.96-.17-13.36-.77-10.44-1.43-18.83-10.75-18.89-21.13-.11-18.72-.11-37.45.14-56.16.18-13.91,9.6-23.03,23.75-23.37,6.68-.16,13.36-.03,20.91-.03.22-3.4.57-6.36.58-9.33.14-35.18-1.42-70.46.7-105.51,3.09-51.01,37.88-97.43,94.51-109.68,51.64-11.16,96.33,1.66,131.66,43.29Zm-84.05-18.21c-12.23.49-24.61-.09-36.66,1.66-46.87,6.79-76.53,47.3-78.74,87.53-1.89,34.54-.8,69.25-1,103.88-.01,1.88.32,3.77.52,5.86h199.76c0-35.1.14-69.7-.12-104.3-.05-6.6-.83-13.42-2.66-19.74-11.75-40.53-37.98-65.87-81.11-74.9Zm-81.3,246.99c-20.39,0-40.77,0-61.16.01-17.19,0-17.25.02-17.49,17.11-.13,8.76-.02,17.53-.02,26.27h289.26v-43.39h-210.59Z"
      />
      <path
        className="cls-5"
        d="M384.72,177.32c.17-4.13-.09-7.55.61-10.77,1.93-8.86,8.79-8.67,15.78-8.11,6.81.54,8.69,4.85,8.68,10.83-.03,19.54.08,39.09-.05,58.63-.07,9.84-4.19,15.29-11.38,15.79-6.71.46-12.31-4.83-12.8-14.52-.87-16.99-.62-34.04-.84-51.86Z"
      />
      <path
        className="cls-1"
        d="M495.79,244.62c-2.01,3.7-3.4,7.05-5.36,10.02-3.36,5.09-7.64,8.23-14.03,4.68-5.98-3.33-10.1-8.62-7.33-15.04,7.31-16.95,15.46-33.55,23.79-50.04,3.45-6.85,9.77-6.78,15.87-3.58,6.3,3.31,8.62,8.34,5.33,15.28-6.03,12.69-11.94,25.44-18.27,38.68Z"
      />
      <path
        className="cls-1"
        d="M260.01,295.57c.48,5.46,1.7,10.86.22,15.36-2.61,7.94-7.06,8.99-14.01,4.35-14.27-9.52-28.49-19.1-42.54-28.95-8.3-5.82-8.62-18.35-.03-23.43,2.88-1.7,9.14-.42,12.39,1.72,14.79,9.73,29.05,20.25,43.97,30.94Z"
      />
      <path
        className="cls-1"
        d="M588.04,288.15c-12.54,9.72-24.71,18.93-36.65,28.41-4.95,3.93-9.57,4.75-13.66-.53-4.06-5.24-7.42-11.63-1.3-17.05,14.54-12.89,29.61-25.18,44.61-37.53,4.69-3.86,8.8-1.55,12.31,2.34,4.79,5.31,5.96,13.81,2.14,18.14-1.98,2.25-4.64,3.9-7.45,6.21Z"
      />
      <path
        className="cls-1"
        d="M291.13,188.91c7.79.2,12.03,3.67,14.82,10.46,5.86,14.26,12.98,28.01,18.57,42.37,1.53,3.92.9,10.22-1.4,13.62-1.82,2.69-7.89,3.87-11.77,3.38-3.09-.39-6.91-3.76-8.38-6.79-7.43-15.32-14.32-30.91-21.15-46.52-3.37-7.71-.88-12.08,9.31-16.52Z"
      />
    </g>
  </svg>
);

export default SirenIcon;
